import { useMutation } from '@apollo/client';
import { Card } from 'antd';
import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { ROUTES } from '../../../common/constants';
import GoBackButton from '../../../components/GoBackButton';
import Portal from '../../../components/Portal';
import history from '../../../historyData';
import RoleForm from '../components/RoleForm';
import { CREATE_ROLE } from '../graphql/Mutations';

function RoleCreate() {
  const [submitLoading, setSubmitLoading] = useState(false);
  const [createRole] = useMutation(CREATE_ROLE, {
    onError: () => {
      setSubmitLoading(false);
    }
  });

  const handleSubmit = async (formValues) => {
    setSubmitLoading(true);

    const newFormValues = {
      ...formValues
    };

    const variables = newFormValues;

    try {
      const response = await createRole({
        variables: { data: { ...variables } }
      });
      if (response?.data?.createRole) {
        history?.push(ROUTES?.ROLES);
      }
    } catch (error) {
      setSubmitLoading(false);
      return error;
    }
  };

  const initialValues = {
    description: ''
  };

  return (
    <Card className="full-height-card card-body-padding">
      <Portal portalId="header-left-content">
        <div className="d-flex align-center">
          <GoBackButton customLink={ROUTES?.ROLES} />
          <span className="portal-header">Add Role</span>
        </div>
      </Portal>
      <RoleForm
        roleData={initialValues}
        handleSubmit={handleSubmit}
        isSubmit={submitLoading}
      />
    </Card>
  );
}

export default withRouter(RoleCreate);
